import { useWallets } from '@privy-io/react-auth';
import { useEVMContext } from '@vertex-protocol/react-client';

interface PrivyWalletLike {
  address?: string | null;
  walletClientType?: string | null;
}

function normalizeAddress(address?: string | null) {
  return address?.toLowerCase();
}

export function isPrivyEmbeddedWallet(
  wallet: PrivyWalletLike | undefined,
  connectedAddress?: string | null,
) {
  if (wallet?.walletClientType !== 'privy') {
    return false;
  }

  if (!connectedAddress) {
    return true;
  }

  if (!wallet.address) {
    return false;
  }

  return normalizeAddress(wallet.address) === normalizeAddress(connectedAddress);
}

export function useIsPrivyEmbeddedWallet() {
  const { wallets } = useWallets();
  const {
    connectionStatus: { address },
  } = useEVMContext();

  return wallets.some((wallet) => isPrivyEmbeddedWallet(wallet, address));
}
